<div class="tiime-overlay-container">
  <mat-icon
    fontIcon="icon-ic-croix"
    class="tiime-overlay-container-close-icon"
    (click)="close()"
  ></mat-icon>
  <ng-content></ng-content>
</div>
